import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const RTOKENS_URL = 'https://yields.reserve.org'

const hyUSD = 'High Yield USD Base::HYUSD'
const bsdETH = 'Based ETH::BSDETH'
const ethPlus = 'ETHPlus::ETH+'
const woEth = 'Wrapped OETH::WOETH'
const sfrxeth = 'Staked Frax Ether::sfrxETH'
const ceth = 'cETH::CETH'
const sfrax = 'Staked FRAX::SFRAX'
const usdThree = 'Web 3 Dollar::USD3'

export const rtokensFetcher: YieldFetcher = {
  label: 'RTOKENS',
  fetch: async () => {
    const res = await fetch(RTOKENS_URL).then((r) => r.json())
    const data = res?.rtokens?.['8453']
    const dataMainnet = res?.rtokens?.['1']
    const dataMainnetColalterals = res?.collaterals?.['1']
    const sfrxethApr = apyToAprPercent((dataMainnetColalterals?.sfrxeth ?? 0) / 100) * 100
    return {
      [bsdETH]: apyToAprPercent((data?.bsdETH ?? 0) / 100) * 100,
      [hyUSD]: apyToAprPercent((data?.hyUSD ?? 0) / 100) * 100,
      [sfrxeth]: sfrxethApr,
      // token-lists unifies every sfrxETH deployment to the bare `SFRXETH` group — emit there too.
      SFRXETH: sfrxethApr,
      [sfrax]:
        apyToAprPercent((dataMainnetColalterals?.sfrax ?? 0) / 100) * 100,
      [ceth]:
        apyToAprPercent((dataMainnetColalterals?.ceth ?? 0) / 100) * 100,
      [ethPlus]: apyToAprPercent((dataMainnet?.['ETH+'] ?? 0) / 100) * 100,
      [usdThree]: apyToAprPercent((dataMainnet?.['USD3'] ?? 0) / 100) * 100,
      [woEth]:
        apyToAprPercent((dataMainnetColalterals?.woeth ?? 0) / 100) * 100,
    }
  },
}
